import type { OsrmTrip } from './osrm';

/**
 * F5.6 — GPX 1.1 route serialiser.
 *
 * Output is a single `<rte>` (route) with one `<rtept>` per stop, in
 * OSRM-optimized order. Garmin, Google Earth and most GPS hardware
 * accept this. We don't include the full polyline geometry as a `<trk>` —
 * keeping the file small and editable. Re-routing is the navigation
 * device's job.
 */

function escapeXml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

export function buildGpx(trip: OsrmTrip, planName = 'Lodestar visit plan'): string {
  const generatedAt = new Date().toISOString();
  const rtepts = trip.ordered
    .map(
      (s) =>
        `    <rtept lat="${s.lat.toFixed(6)}" lon="${s.lon.toFixed(6)}">
      <name>${escapeXml(s.name)}</name>
    </rtept>`,
    )
    .join('\n');
  return `<?xml version="1.0" encoding="UTF-8"?>
<gpx version="1.1" creator="Lodestar" xmlns="http://www.topografix.com/GPX/1/1">
  <metadata>
    <name>${escapeXml(planName)}</name>
    <time>${generatedAt}</time>
  </metadata>
  <rte>
    <name>${escapeXml(planName)}</name>
${rtepts}
  </rte>
</gpx>
`;
}

export function downloadGpx(trip: OsrmTrip, planName?: string): void {
  const xml = buildGpx(trip, planName);
  const blob = new Blob([xml], { type: 'application/gpx+xml' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  const datestamp = new Date().toISOString().slice(0, 10);
  a.download = `visit-plan-${datestamp}.gpx`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
